import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { stringInputSpec } from '../../lib/editing-configs';
import AppStoreButton from './app-store-button';
import GooglePlayButton from './google-play-button';

import './app-buttons.scss';

const DEFAULT_APP_STORE_URL =
  'https://nerdwallet.onelink.me/3687710914/2340937a';
const DEFAULT_GOOGLE_PLAY_URL =
  'https://nerdwallet.onelink.me/3687710914/b99e5635';

const AppButtons = ({ appStoreURL, className, googlePlayURL }) => {
  return (
    <div className={classnames(className, 'app-buttons')}>
      <AppStoreButton url={appStoreURL} />
      <GooglePlayButton url={googlePlayURL} />
    </div>
  );
};

AppButtons.propTypes = {
  appStoreURL: PropTypes.string,
  className: PropTypes.string,
  googlePlayURL: PropTypes.string,
};

AppButtons.defaultProps = {
  appStoreURL: DEFAULT_APP_STORE_URL,
  className: '',
  googlePlayURL: DEFAULT_GOOGLE_PLAY_URL,
};

AppButtons.getEditingConfig = () => [
  stringInputSpec('appStoreURL', 'App store URL'),
  stringInputSpec('googlePlayURL', 'Google play store URL'),
];

AppButtons.displayName = 'AppButtons';

export default AppButtons;
